import { NavItem } from "@/interfaces/nav";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import {
  Inbox,
  LinkedinIcon,
  Rows3Icon,
  CodeXmlIcon,
  File,
  CookieIcon,
  SparklesIcon,
  SearchCodeIcon,
  CircleUserRound,
  ListChecksIcon,
  Files,
  FilePen,
  FileText,
  MessageCircle,
  BotMessageSquareIcon,
  GitCompare,
} from "lucide-react";

export const loginPath = "/auth/signin";
export const homepagePath = "/Cambio/inbox";
export const settingsPath = `/settings`;

export const navClientItems = [
  { name: "Inbox", href: "inbox", icon: Inbox },
  { name: "Reachouts", href: "reachouts", icon: MessageCircle },
  {
    name: "Accounts",
    href: "accounts",
    icon: CircleUserRound,
    disableParentPath: true,
  },
  { name: "Campaigns", href: "campaigns", icon: Files },
] as NavItem[];

export const navToolItems = [
  { name: "LinkedIn Search", href: "/linkedInSearch", icon: SearchCodeIcon },
  {
    name: "Scheduled Runs",
    href: "/linkedInSearch/scheduled",
    icon: Rows3Icon,
  },
  { name: "Draft", href: "draft", icon: FileText },
  { name: "Qualify", href: "/qualify", icon: ListChecksIcon },
  { name: "Enrich Person", href: "/enrich/personal", icon: CodeXmlIcon },
  { name: "Enrich Company", href: "/enrich/company", icon: CodeXmlIcon },
  { name: "Search Email", href: "/search-email", icon: MagnifyingGlassIcon },
  { name: "Message Versions", href: "/message-versions", icon: GitCompare },
] as NavItem[];
